Number.prototype.getPrecision = function () {
  let arr = (this.valueOf() + '').split('.');
  let result = 0;
  if (arr[1]) result = arr[1].length;
  return result;
};
